module.exports = __webpack_public_path__ + "img/TZS09676.eb1804eb.jpeg";